import "./StopoverDuration.scss";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedPlural } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import RadioFormik from "app/pages/.shared/form/RadioFormik";

const StopoverDuration = ({ duration, onDurationSelect = () => {} }) => {
	const handleDurationChange = () => {
		onDurationSelect(duration);
	};

	return (
		<RadioFormik
			name="duration"
			id={`stopover-duration-${duration}`}
			value={duration}
			toggle={handleDurationChange}
			showIcon={true}
			className="stopover-duration"
			data-testid={`stopover-duration-${duration}`}
		>
			<div className="stopover-duration__content">
				<div className="stopover-duration__day">
					<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
						<FormattedPlural
							value={duration}
							one={
								<FormattedMessage
									values={{
										duration,
									}}
									id="general.duration.days.singular"
								/>
							}
							other={
								<FormattedMessage
									values={{
										duration,
									}}
									id="general.duration.days.plural"
								/>
							}
						/>
					</Typography>
				</div>
				<div className="stopover-duration__night">
					<Typography variant={TYPOGRAPHY_VARIANTS.LARGE}>
						(
						<FormattedPlural
							value={duration}
							one={
								<FormattedMessage
									values={{
										duration,
									}}
									id="general.duration.stopover.night.singular"
								/>
							}
							other={
								<FormattedMessage
									values={{
										duration,
									}}
									id="general.duration.stopover.night.plural"
								/>
							}
						/>
						)
					</Typography>
				</div>
			</div>
		</RadioFormik>
	);
};

StopoverDuration.propTypes = {
	duration: PropTypes.number,
	onDurationSelect: PropTypes.func,
};

export default StopoverDuration;
